import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageLocationsList,
  PageLocation,
} from '../pages/locations';

const RouteLocations = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageLocationsList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageLocation />
      </Route>
    </Switch>
  );
};

export default RouteLocations;
